import {SettingParams} from './config.model';
import {Platform} from 'react-native';

const webBaseUrl = 'https://lk-api.karta51.ru/HPA/API/1_0/';
const mobileBaseUrl = 'https://mobile-api.karta51.ru/MobileApp/API/1_0/';

export const settings: SettingParams = {
  baseUrl: {
    uralsoccard: Platform.OS === 'web' ? webBaseUrl : mobileBaseUrl,
    transportCard: 'https://api.karta51.ru/api/v0/',
    dobroru: 'https://dobro.ru/api/v2',
  },
};
